import Vue from 'vue'
import router from 'vue-router'
import Home from '../view/index.vue'
Vue.use(router)
export default new router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },


  ]
})

